export enum AutomationRequestPrivacyLevel {
	Public,
	Private
}
